import useGetOrg from "src/hooks/useGetOrganization";
import { useGetOrgUsersRequest } from "src/services/organizations/queries/users";

export const useGetOrgUsers = () => {
	const { id } = useGetOrg();

	const { data, isLoading } = useGetOrgUsersRequest(id);

	return { rows: data ?? [], isLoading };
};
